import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeForm();
  }

  initializeForm() {
    // Call your existing function
    if (window.initAssessorProfileForm) {
      window.initAssessorProfileForm();
    }
  }
}